import React from "react";
import { Link } from "react-router-dom";
const SearchBar = ({
  setSearchValue,
  setKeyValue,
  searchValue,
  placeholder,
  btn_value,
  btn_link,
}) => {


  const isEnter = (e) => {
    if (e.code === "Enter") {
      if (e.target.value != searchValue) {
        setSearchValue(e.target.value);
        setKeyValue(e.code);
      }
    }
      if(e.target.value != searchValue && e.target.value.length == 0){
        setSearchValue(e.target.value);
        setKeyValue("Enter");
      }

  };
  return (
    <>
      <div className="searchPanel">
        <div className="searchBar" style={{width:"35%"}}>
          <i className="material-symbols-rounded mt-m grey">search</i>
          <input type="search" placeholder={placeholder} onKeyUp={isEnter} />
        </div>
        {btn_value?<Link to={btn_link} className="btn prim">
          {btn_value}
        </Link>:""}
      </div>
    </>
  );
};
export default SearchBar;
